import { useEffect } from "react";
import { createPortal } from "react-dom";
import closeIcon from "../../../../../../../../../utilities/images/package_mastery_upgrade/icon-close.svg";
import checkIcon from "../../../../../../../../../utilities/images/package_mastery_upgrade/icon-check-miss.svg";
import highlightIcon from "../../../../../../../../../utilities/images/package_mastery_upgrade/icon-highlight.svg";
import "./StoreMasteryUpgradeModal.scss";

const SECTION_TOKENS = [
  { token: "l", word: "learn", label: "Learn" },
  { token: "p", word: "practice", label: "Practice" },
  { token: "t", word: "test", label: "Test" },
];

export const sectionsLabel = (name = "") => {
  const lower = String(name).toLowerCase();
  const paren = (lower.match(/\(([^)]+)\)/) || [])[1] || "";
  const tokens = paren
    ? paren.replace(/\s/g, "").split("+").filter(Boolean)
    : [];
  const parts = SECTION_TOKENS.filter((section) => {
    if (tokens.length) return tokens.includes(section.token);
    return new RegExp(`\\b${section.word}\\b`).test(lower);
  }).map((section) => section.label);
  return parts.join(" + ");
};

const durationSuffix = (name = "") => {
  const text = String(name).toLowerCase();
  if (/2\s*years?/.test(text)) return "/2 yr";
  if (/6\s*months?/.test(text)) return "/6 mo";
  if (/1\s*year/.test(text)) return "/yr";
  return "";
};

const formatRupee = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "";
  const rounded = Number.isInteger(amount) ? amount : Math.round(amount);
  return `₹${rounded.toLocaleString("en-IN")}`;
};

const StoreMasteryUpgradeModal = ({
  open,
  onClose,
  onUpgrade,
  currentName,
  offer,
  features,
  payPrice,
  listPrice,
}) => {
  const currentPlan = sectionsLabel(currentName) || "this plan";
  const masteryPlan = sectionsLabel(offer?.upgrade_package_name) || "Learn + Practice + Test";
  const saveRupees = Math.max(0, Math.round(Number(listPrice) - Number(payPrice)));
  const savePercent =
    listPrice > 0 ? Math.round((saveRupees / listPrice) * 100) : 0;
  const saveLabel =
    savePercent >= 1
      ? `Save ${savePercent}%`
      : saveRupees >= 1
      ? `Save ₹${saveRupees.toLocaleString("en-IN")}`
      : "";

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === "Escape") onClose();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="upgrade-popup__backdrop" onClick={onClose}>
      <div className="upgrade-popup">
        <button
          type="button"
          className="upgrade-popup__close"
          aria-label="Close"
          onClick={onClose}
        >
          <img src={closeIcon} alt="" />
        </button>
        <div
          className="upgrade-popup__dialog"
          role="dialog"
          aria-modal="true"
          aria-labelledby="upgrade-popup-title"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="upgrade-popup__header">
            <h2 id="upgrade-popup-title">Wait, you&apos;re missing out!</h2>
            <p>
              You&apos;re purchasing <strong>{currentPlan} only</strong>. Upgrade to the{" "}
              <span className="upgrade-popup__mastery">
                Mastery Bundle
                <span className="upgrade-popup__highlight">
                  <img src={highlightIcon} alt="" />
                </span>
              </span>{" "}
              for complete access.
            </p>
          </div>

          <div className="upgrade-popup__plan">
            <div className="upgrade-popup__plan-main">
              <div>
                <div className="upgrade-popup__plan-title">
                  <span>Mastery Bundle</span>
                  {offer?.tag ? <em>{offer.tag}</em> : null}
                </div>
                <p>{masteryPlan}</p>
              </div>
              <div className="upgrade-popup__price">
                <strong>
                  {formatRupee(payPrice)}
                  <span>{durationSuffix(offer?.upgrade_package_name)}</span>
                </strong>
                {saveLabel ? <span>{saveLabel}</span> : null}
              </div>
            </div>
          </div>

          {features.length ? (
            <div className="upgrade-popup__miss">
              <p>WHAT YOU WILL MISS:</p>
              <ul>
                {features.map((feature) => (
                  <li key={feature}>
                    <img src={checkIcon} alt="" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ) : null}

          <div className="upgrade-popup__actions">
            <button type="button" className="upgrade-popup__upgrade" onClick={onUpgrade}>
              {offer?.button_text || "Upgrade to Mastery"}
            </button>
            <button type="button" className="upgrade-popup__stay" onClick={onClose}>
              No thanks, continue with {currentPlan} only
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default StoreMasteryUpgradeModal;
